/// <reference types="jquery" />
/*
JPH 2022-02-03
Pour le masquage des capteurs voir la méthode "updatePrevisionIndicatorVisibility",
si tu mets un return en première instruction, le masquage sera skippé.

Pour les stations :
pour données horaires c'est dans la fonction "initializePameSebStationsHourly",
pour les données journalière voir la fonction "initializePameSebStationsDaily"

voir //MH : Uncomment to disable sensors and stations filter

*/
/* load styles */
import "./css/introjs.css";
import "./css/ol.css";
import introJs from "intro.js";
import Swal from "sweetalert2";
import Map from "ol/Map";
import Overlay from "ol/Overlay";
import View from "ol/View";
import Feature from "ol/Feature";
import { fromLonLat, transform } from "ol/proj";
import { Tile, Vector } from "ol/layer";
import { TileWMS, Vector as VectorSource } from "ol/source";
import { Fill, Icon, Stroke, Style, Text } from "ol/style";
import { ScaleLine, defaults as ctrldefaults } from "ol/control";
import { defaults as intdefaults, DragPan, MouseWheelZoom, } from "ol/interaction";
import { Point } from "ol/geom";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
var init = function () {
    /*  initialisation des HTML events*/
    window.addEventListener("click", function (e) {
        var el = e.target;
        if (!(el instanceof Node &&
            document.getElementById("info_selectors").contains(el))) {
            closeOutMeasureList();
        }
    });
    /**
     * Lister les elements à scruter
     */
    var addOSMButton = document.getElementById("addOSMButton");
    var addParcelsButton = document.getElementById("addParcelsButton");
    var addSatOSMButton = document.getElementById("addSatOSMButton");
    var addSpatialTemparatureButton = document.getElementById("addSpatialTemparatureButton");
    var toggleStationsButton = document.getElementById("toggleStationsButton");
    var switchToHourlyButton = document.getElementById("switchToHourlyButton");
    var switchToDailyButton = document.getElementById("switchToDailyButton");
    var minButton = document.getElementById("min");
    var avgButton = document.getElementById("avg");
    var maxButton = document.getElementById("max");
    var playButtonAnimation = document.getElementById("playButtonAnimation");
    var pauseButtonAnimation = document.getElementById("pauseButtonAnimation");
    var hoursRangeButton = document.getElementById("hoursRange");
    var daysRangeButton = document.getElementById("daysRange");
    var dateSelectButton = document.getElementById("dateSelect");
    var introButton = document.getElementById("introButton");
    var infoSelectors = document.getElementById("info_selectors");
    var popupMsgToUserClose = document.getElementById("popup-msg-to-user-close");
    var tsaButton = document.getElementById("tsa");
    var tsfButton = document.getElementById("tsf");
    var tssButton = document.getElementById("tss");
    var ensButton = document.getElementById("ens");
    var pluButton = document.getElementById("plu");
    var hraButton = document.getElementById("hra");
    var hctButton = document.getElementById("hct");
    var vvtButton = document.getElementById("vvt");
    var dvtButton = document.getElementById("dvt");
    /**
     * Lister les évènements
     */
    addOSMButton.addEventListener("click", addOSMToMap);
    addParcelsButton.addEventListener("click", toggleAgriWMSToMap);
    addSatOSMButton.addEventListener("click", toggleSatOSMToMap);
    addSpatialTemparatureButton.addEventListener("click", toggleTempartureMap);
    popupMsgToUserClose.addEventListener("click", closeMsgToUserPopup);
    toggleStationsButton.addEventListener("click", toggleStations);
    switchToHourlyButton.addEventListener("click", switchToHourly);
    switchToDailyButton.addEventListener("click", switchToDaily);
    minButton.addEventListener("click", function () {
        setDailyDailyDataUnit("min");
    });
    avgButton.addEventListener("click", function () {
        setDailyDailyDataUnit("avg");
    });
    maxButton.addEventListener("click", function () {
        setDailyDailyDataUnit("max");
    });
    playButtonAnimation.addEventListener("click", startAnimation);
    pauseButtonAnimation.addEventListener("click", pauseAnimation);
    hoursRangeButton.addEventListener("input", function (event) {
        var el = { target: { value: event.target.value } };
        hourChanged(el);
    });
    daysRangeButton.addEventListener("input", function (event) {
        var el = { target: { value: event.target.value } };
        dayChanged(el);
    });
    dateSelectButton.addEventListener("input", dateSelected);
    introButton.addEventListener("click", startIntro);
    infoSelectors.addEventListener("mouseover", openHoverMeasureList);
    tsaButton.addEventListener("click", function (e) {
        var el = e.target;
        if (!((el.parentElement.localName == "li" ||
            el.parentElement.localName == "button") &&
            el.parentElement.classList.contains("selected"))) {
            setMeasure("tsa");
        }
        else {
            openMeasureList();
        }
    });
    tsfButton.addEventListener("click", function (e) {
        var el = e.target;
        if (!((el.parentElement.localName == "li" ||
            el.parentElement.localName == "button") &&
            el.parentElement.classList.contains("selected"))) {
            setMeasure("tsf");
        }
        else {
            openMeasureList();
        }
    });
    tssButton.addEventListener("click", function (e) {
        var el = e.target;
        if (!((el.parentElement.localName == "li" ||
            el.parentElement.localName == "button") &&
            el.parentElement.classList.contains("selected"))) {
            setMeasure("tss");
        }
        else {
            openMeasureList();
        }
    });
    ensButton.addEventListener("click", function (e) {
        var el = e.target;
        if (!((el.parentElement.localName == "li" ||
            el.parentElement.localName == "button") &&
            el.parentElement.classList.contains("selected"))) {
            setMeasure("ens");
        }
        else {
            openMeasureList();
        }
    });
    pluButton.addEventListener("click", function (e) {
        var el = e.target;
        if (!((el.parentElement.localName == "li" ||
            el.parentElement.localName == "button") &&
            el.parentElement.classList.contains("selected"))) {
            setMeasure("plu");
        }
        else {
            openMeasureList();
        }
    });
    hraButton.addEventListener("click", function (e) {
        var el = e.target;
        if (!((el.parentElement.localName == "li" ||
            el.parentElement.localName == "button") &&
            el.parentElement.classList.contains("selected"))) {
            setMeasure("hra");
        }
        else {
            openMeasureList();
        }
    });
    hctButton.addEventListener("click", function (e) {
        var el = e.target;
        if (!((el.parentElement.localName == "li" ||
            el.parentElement.localName == "button") &&
            el.parentElement.classList.contains("selected"))) {
            setMeasure("hct");
        }
        else {
            openMeasureList();
        }
    });
    vvtButton.addEventListener("click", function (e) {
        var el = e.target;
        if (!((el.parentElement.localName == "li" ||
            el.parentElement.localName == "button") &&
            el.parentElement.classList.contains("selected"))) {
            setMeasure("vvt");
        }
        else {
            openMeasureList();
        }
    });
    dvtButton.addEventListener("click", function (e) {
        var el = e.target;
        if (!((el.parentElement.localName == "li" ||
            el.parentElement.localName == "button") &&
            el.parentElement.classList.contains("selected"))) {
            setMeasure("dvt");
        }
        else {
            openMeasureList();
        }
    });
};
// Raster OpenLayer objects
var parcelsTileLayer;
var baseSatTileLayer;
var temperatureBaseLayers = [];
var baseTileLayer;
// Station data and style
var geoJsonPamesebStations;
var pamesebStationStyle;
// Map interface logic
var map;
var hourly = true;
var daily = false;
var stationsVisible = true;
var fixedStepColorsTemperature = true;
var fixedStepColorsHRA = false;
var spatialPixelClicked = false;
var temperatureBaseLayersActivated = false;
// Getting most recent data available
var getLastAvailableDatetime = function () {
    return new Date(document.getElementById("last_available_datetime").value);
};
// const lastAvailableDatetime: Date = new Date(
//   $("#last_available_datetime").val()
// );
// go 2 hours back to be sure to have full data
//lastAvailableDatetime.setHours(lastAvailableDatetime.getHours() - 2);
var currentDateSlider = getLastAvailableDatetime();
var daySliderCentered = false;
// Initialisation variable of dates and urls
var spatialFeatureInfoJSON;
var lastHoverFeatureInfoRequest = Date.now();
var currentHour = getLastAvailableDatetime().getHours();
document.getElementById("labelHour").innerHTML = "".concat(currentHour, "H");
var currentDate = getLastAvailableDatetime();
document.getElementById("hoursRange").value =
    currentHour.toString();
document.getElementById("dateSelect").value = currentDate
    .toISOString()
    .substring(0, 10);
// Sensors variable initialization
var maxSpatialTemperature;
var minSpatialTemperature;
var availableSpatializedMeasures = ["tsa", "hra"];
var currentSpatialisedDataMeasure = "";
var geo_base_url = "https://agromet.be";
//Station datas
// let hourlyData = {};
var hourlyData = [];
var dailyData = [];
// let stationsData = {};
var stationsData = [];
var stationLayers = [];
//avg,min,max,sum
var currentDailyDataUnit = "avg";
// HTML Elements
var popupContainer = document.getElementById("popup");
var popupContent = document.getElementById("popup-content");
var popupCloser = document.getElementById("popup-closer");
var popupContainerHover = document.getElementById("popup-hover");
var popupContentHover = (document.getElementById("popup-content-hover"));
var popupHoverCloser = (document.getElementById("popup-hover-closer"));
var popupOverlayHover;
var popupOverlay;
var animationInterval;
var userToken = document.getElementById("user_token").value;
var msgToUser = document.getElementById("msg_to_user")
    .value;
var msgToUserStart = new Date(document.getElementById("msg_to_user_start").value);
var msgToUserEnd = new Date(document.getElementById("msg_to_user_end").value);
var previsionEnabled = document.getElementById("prevision_enabled").value ==
    "False"
    ? false
    : true;
var previsional = false;
var userStationsRestriction = (document.getElementById("user_stations")).value.split(",");
var userSensorsRestriction = (document.getElementById("user_sensors")).value.split(",");
var currentMeasure = "tsa";
if (userSensorsRestriction.includes("tsa") ||
    userSensorsRestriction.includes("anonymous") ||
    userSensorsRestriction[0] == "") {
    currentMeasure = "tsa";
}
else {
    currentMeasure = userSensorsRestriction[0];
}
setMeasure(currentMeasure);
updatePrevisionIndicatorVisibility();
/**
 * Main initialization methods
 */
initMap();
initializePameSebStations();
closeOutMeasureList();
if (getCookie("showMsgToUser") != "false") {
    initializeMsgToUserPopup();
}
/**
 * Utility function to get the base URL we are on.
 * */
function getBaseURL() {
    var getUrl = window.location;
    // let baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
    var baseUrl = getUrl.protocol + "//" + getUrl.host;
    return baseUrl;
}
/* Manage Selected layers style */
function classSelectedToBaseLayerButton(index) {
    var addParcelsButton = (document.getElementById("addParcelsButton"));
    var addOSMButton = document.getElementById("addOSMButton");
    var addSpatialTemparatureButton = (document.getElementById("addSpatialTemparatureButton"));
    var addSatOSMButton = document.getElementById("addSatOSMButton");
    var buttons = [
        addParcelsButton,
        addOSMButton,
        addSatOSMButton,
        addSpatialTemparatureButton,
    ];
    classSelectedToButton(buttons, index);
}
/**
 * Highlight the @param index button with the "selected" style
 */
function classSelectedToButton(buttons, index) {
    buttons.forEach(function (button) {
        return button.classList.remove("selected");
    });
    buttons[index].classList.add("selected");
}
/**
 * Set agriculture parcels on focus
 */
function toggleAgriWMSToMap() {
    if (parcelsTileLayer.getVisible()) {
        resetMapsZIndex();
    }
    else {
        resetMapsZIndex();
        map.addLayer(parcelsTileLayer);
        parcelsTileLayer.setZIndex(15);
        parcelsTileLayer.setVisible(true);
        classSelectedToBaseLayerButton(0);
    }
}
/**
 * Set temperature map on focus
 */
/**
 * Toggle stations marker and update selection button
 */
function toggleStations() {
    if (stationsVisible) {
        hideStations();
    }
    else {
        showStations();
    }
    stationsVisible = !stationsVisible;
}
/**
 * Toggle spatialised temperature
 */
function toggleTempartureMap() {
    if (temperatureBaseLayersActivated) {
        resetTemperatureMap();
    }
    else {
        resetTemperatureMap();
        addTemperatureToMap();
    }
}
/**
 * Does the opposite of toggleTemperatureMap
 */
function switchSpatialMap() {
    if (temperatureBaseLayersActivated) {
        resetTemperatureMap();
        addTemperatureToMap();
    }
    else {
        resetTemperatureMap();
    }
}
// function temperatureLegendShow(): void {
//   document.querySelector<HTMLElement>("#layer_legend_tsa")!.hidden = false;
// }
// function temperatureLegendHide(): void {
//   document.querySelector<HTMLElement>("#layer_legend_tsa")!.hidden = true;
// }
function sensorLegendShow(sensor) {
    document.querySelector("#layer_legend_" + sensor).hidden =
        false;
}
function sensorLegendHide() {
    document.querySelector("#layer_legend_tsa").hidden = true;
    document.querySelector("#layer_legend_hra").hidden = true;
}
/**
 * Initialize spatialized temperature and draw it on map
 */
var paramsTests = [];
function addTemperatureToMap() {
    /* JPH 2023-06-28 limit functionality for spatialized measures */
    classSelectedToBaseLayerButton(3);
    //let hour = currentHour;
    // sensorLegendHide();
    resetTemperatureMap();
    if (currentSpatialisedDataMeasure != "") {
        temperatureBaseLayersActivated = true;
        sensorLegendShow(currentSpatialisedDataMeasure);
        if (hourly)
            addHourlyTemperatureToMap();
        else
            addDailySpatialTemperatureToMap();
    }
    else {
        temperatureBaseLayersActivated = false;
    }
    reorderSpatialTemperature();
}
function addHourlyTemperatureToMap() {
    var temperatureMapDate = currentDate;
    temperatureBaseLayers = [];
    paramsTests = [];
    for (var hour = 0; hour < 24; hour++) {
        temperatureMapDate.setHours(hour);
        var year = temperatureMapDate.getUTCFullYear();
        var month = temperatureMapDate.getUTCMonth() + 1;
        var day = temperatureMapDate.getUTCDate();
        var utcHour = temperatureMapDate.getUTCHours();
        var layerParams = {
            LAYERS: "agromet:spatial_" + currentSpatialisedDataMeasure,
            viewparams: "YEAR:".concat(year, ";MONTH:").concat(month, ";DAY:").concat(day, ";HOUR:").concat(utcHour, ";"),
            TILED: true,
            env: "",
        };
        paramsTests.push(layerParams);
        temperatureBaseLayers.push({
            dateLayer: temperatureMapDate,
            hour: hour,
            utcHour: utcHour,
            olLayer: new Tile({
                source: new TileWMS({
                    url: geo_base_url + "/geoserver/agromet/wms",
                    params: layerParams,
                    serverType: "geoserver",
                    transition: 0,
                }),
                opacity: 0.9,
                zIndex: -1,
            }),
        });
        map.addLayer(temperatureBaseLayers[hour].olLayer);
    }
}
function addDailySpatialTemperatureToMap() {
    temperatureBaseLayers = [];
    paramsTests = [];
    var temperatureMapDate = currentDate;
    for (var day = 0; day < 14; day++) {
        var tempDate = new Date(temperatureMapDate.getTime());
        tempDate.setDate(tempDate.getDate() - day);
        var year = tempDate.getUTCFullYear();
        var month = tempDate.getUTCMonth() + 1;
        var utcday = tempDate.getUTCDate();
        var layerParams = {
            LAYERS: "agromet:spatial_daily_" +
                currentSpatialisedDataMeasure +
                "_" +
                currentDailyDataUnit,
            viewparams: "YEAR:".concat(year, ";MONTH:").concat(month, ";DAY:").concat(utcday, ";"),
            TILED: true,
            env: "",
        };
        paramsTests.push(layerParams);
        temperatureBaseLayers.push({
            dateLayer: tempDate,
            day: tempDate.getDate(),
            utcDay: tempDate.getUTCDate(),
            olLayer: new Tile({
                source: new TileWMS({
                    url: geo_base_url + "/geoserver/agromet/wms",
                    params: layerParams,
                    serverType: "geoserver",
                    transition: 0,
                }),
                opacity: 0.9,
                zIndex: -1,
            }),
        });
        map.addLayer(temperatureBaseLayers[day].olLayer);
    }
    sensorLegendHide();
    sensorLegendShow(currentSpatialisedDataMeasure);
}
/**
 *   Reorder spatial temparture layers based on the date and time selected.
 */
function reorderSpatialTemperature() {
    if (temperatureBaseLayers == null)
        return;
    // we need to point to the UTC hour and day while they are in localtime
    currentDate.setHours(currentHour);
    var utcCurrentHour;
    var utcCurrentDate;
    if (hourly)
        utcCurrentHour = currentDate.getUTCHours();
    else
        utcCurrentDate = currentDateSlider.getUTCDate();
    temperatureBaseLayers.forEach(function (tempartureLayer) {
        tempartureLayer.olLayer.setZIndex(-1);
        tempartureLayer.olLayer.setVisible(false);
        if (tempartureLayer.utcHour != null &&
            tempartureLayer.utcHour == utcCurrentHour) {
            tempartureLayer.olLayer.setZIndex(15);
            tempartureLayer.olLayer.setVisible(true);
        }
        else if (tempartureLayer.utcDay != null &&
            tempartureLayer.utcDay == utcCurrentDate) {
            tempartureLayer.olLayer.setZIndex(15);
            tempartureLayer.olLayer.setVisible(true);
        }
    });
}
/**
 * Switch to hourly data acquisition mode and refresh the interface, map and data with current selected date
 */
function switchToHourly() {
    hourly = true;
    daily = false;
    currentDate = currentDateSlider;
    document.getElementById("dateSelect").value = currentDate
        .toISOString()
        .substring(0, 10);
    setDailyDataUnitVisibility();
    var switchToHourlyButton = (document.getElementById("switchToHourlyButton"));
    var switchToDailyButton = (document.getElementById("switchToDailyButton"));
    classSelectedToButton([switchToHourlyButton, switchToDailyButton], 0);
    initInterfaceSliders();
    dateSelected();
}
/**
 * Switch to daily data aqcisition mode and refresh the interface, map and data with current selected date
 */
function switchToDaily() {
    hourly = false;
    daily = true;
    setDailyDataUnitVisibility();
    var switchToHourlyButton = (document.getElementById("switchToHourlyButton"));
    var switchToDailyButton = (document.getElementById("switchToDailyButton"));
    classSelectedToButton([switchToHourlyButton, switchToDailyButton], 1);
    initInterfaceSliders();
    dateSelected();
}
/**
 * Populate Wallonia agriculture parcels layer, openstreetmap layer (base)
 * JPH 2022-08-10 new version using mapproxy
 */
function initWMSLayer() {
    baseTileLayer = new TileLayer({
        source: new XYZ({
            url: geo_base_url + "/mapproxy/tiles/osm/webmercator/{z}/{x}/{y}.png",
            attributions: '&copy; <a href="https://www.met.no/">MET Norway</a> Forecasts<br />' +
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors<br />' +
                '&copy; CRA-W <a href="https://agromet.be">Agromet.be</a><br />' +
                "Avertissement:<br /> données affichées non validées",
        }),
        zIndex: 10,
    });
    parcelsTileLayer = new TileLayer({
        source: new XYZ({
            // url: "https://geoservices.wallonie.be/arcgis/services/AGRICULTURE/SIGEC_PARC_AGRI_ANON__2018/MapServer/WMSServer?",
            url: geo_base_url + "/mapproxy/tiles/sigec/webmercator/{z}/{x}/{y}.png",
            attributions: '&copy; <a href="https://geoportail.wallonie.be/home.html">Geoportail de Wallonie</a><br />',
        }),
        zIndex: 0,
    });
    baseSatTileLayer = new TileLayer({
        source: new XYZ({
            // url: "https://geoservices.wallonie.be/arcgis/services/IMAGERIE/ORTHO_2019/MapServer/WMSServer?",
            url: geo_base_url + "/mapproxy/tiles/ortho2019/webmercator/{z}/{x}/{y}.png",
            attributions: '&copy; <a href="https://geoportail.wallonie.be/home.html">Geoportail de Wallonie</a><br />',
        }),
        zIndex: 0,
    });
}
// function initWMSLayer() {
//   baseTileLayer = new Tile({
//     source: new OSM({
//       attributions:
//         '&copy; <a href="https://www.met.no/">MET Norway</a> Forecasts<br />' +
//         '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors<br />' +
//         '&copy; CRA-W <a href="https://agromet.be">Agromet.be</a><br />' +
//         "Avertissement:<br /> données affichées non validées",
//     }),
//     zIndex: 10,
//   });
//   parcelsTileLayer = new Tile({
//     source: new TileWMS({
//       url: "https://geoservices.wallonie.be/arcgis/services/AGRICULTURE/SIGEC_PARC_AGRI_ANON__2018/MapServer/WMSServer?",
//       params: { LAYERS: "0,2", TILED: true },
//       serverType: "geoserver",
//       transition: 0,
//       // visible: false,
//       attributions:
//         '&copy; <a href="https://geoportail.wallonie.be/home.html">Geoportail de Wallonie</a><br />',
//     }),
//     zIndex: 0,
//   });
//   baseSatTileLayer = new Tile({
//     source: new TileWMS({
//       url: "https://geoservices.wallonie.be/arcgis/services/IMAGERIE/ORTHO_2019/MapServer/WMSServer?",
//       params: { LAYERS: "0", TILED: true },
//       serverType: "geoserver",
//       transition: 0,
//       // visible: false,
//       attributions:
//         '&copy; <a href="https://geoportail.wallonie.be/home.html">Geoportail de Wallonie</a><br />',
//     }),
//     zIndex: 0,
//   });
// }
/**
 * Initialise scale on the bottom left corner of the map
 */
function scaleControl() {
    var control = new ScaleLine({
        units: "metric",
        bar: true,
        steps: 4,
        text: true,
        minWidth: 100,
    });
    return control;
}
/**
 * Create OpenLayer Map and populate it with data
 */
function initMap() {
    initWMSLayer();
    map = new Map({
        target: "map",
        layers: [baseTileLayer],
        view: new View({
            projection: "EPSG:3857",
            center: transform([4.9, 50.05], "EPSG:4326", "EPSG:3857"),
            zoom: 9,
        }),
        interactions: intdefaults({
            dragPan: false,
            mouseWheelZoom: false,
        }).extend([
            // new DragPan({ kinetic: false }),
            new DragPan(),
            new MouseWheelZoom({ duration: 0 }),
        ]),
        controls: ctrldefaults({
            attributionOptions: { collapsible: false },
        }).extend([scaleControl()]),
    });
    initMapInteractions();
    initPopup();
    initPopupHover();
    resetMapsZIndex();
}
/**
 *   Animate the slider automaticaly every 1 sec
 */
function startAnimation() {
    animationInterval = setInterval(function () {
        incrementSlider();
    }, 2000);
    document.getElementById("playButtonAnimation").hidden = true;
    document.getElementById("pauseButtonAnimation").hidden = false;
}
/**
 * Programaticaly increment the date or hour slider and refresh the stations
 */
function incrementSlider() {
    var slider = hourly
        ? document.getElementById("hoursRange")
        : document.getElementById("daysRange");
    var currentSliderValue = slider.value;
    var currentSliderMaxValue = slider.max;
    if (parseInt(currentSliderValue) < parseInt(currentSliderMaxValue)) {
        var newval = parseInt(slider.value) + 1;
        slider.value = newval.toString();
    }
    else {
        slider.value = slider.min;
    }
    var newValue = { target: { value: slider.value } };
    if (hourly)
        hourChanged(newValue);
    if (daily)
        dayChanged(newValue);
}
/**
 * Stop the automatic animation
 */
function pauseAnimation() {
    clearInterval(animationInterval);
    animationInterval = null;
    document.getElementById("playButtonAnimation").hidden = false;
    document.getElementById("pauseButtonAnimation").hidden = true;
}
/**
 * Initialize the spatial overlay popup for marker "onclick" event
 */
function initPopupHover() {
    popupOverlayHover = new Overlay({
        element: popupContainerHover,
        autoPan: false,
        offset: [10, -10],
        stopEvent: false,
    });
    popupHoverCloser.onclick = function () {
        popupOverlayHover.setPosition(undefined);
        popupHoverCloser.blur();
        return false;
    };
    map.addOverlay(popupOverlayHover);
}
/**
 * Initialize the stations overlay popup for marker "onclick" event
 */
function initPopup() {
    popupOverlay = new Overlay({
        element: popupContainer,
        // autoPan: true,
        // autoPanAnimation: {
        //   duration: 250,
        // },
        autoPan: {
            animation: {
                duration: 250,
            },
        },
        offset: [25, -30],
    });
    popupCloser.onclick = function () {
        popupOverlay.setPosition(undefined);
        popupCloser.blur();
        return false;
    };
    map.addOverlay(popupOverlay);
}
/**
 * Initialize click and hover interactions of the Openlayer map
 */
function initMapInteractions() {
    map.on("pointermove", function (e) {
        //Change cursor when hover on stations
        var pixel = map.getEventPixel(e.originalEvent);
        var stationHit = map.hasFeatureAtPixel(pixel);
        if (map.getTarget() != undefined) {
            document.getElementById(map.getTarget().toString()).style.cursor =
                stationHit ? "pointer" : "";
        }
        //Print pop-pup with pixel value on hover of spatial data
        if (spatialPixelClicked)
            return;
        var hoverTimeDifference = Date.now() - lastHoverFeatureInfoRequest;
        if (temperatureBaseLayers != null && hoverTimeDifference > 15) {
            lastHoverFeatureInfoRequest = Date.now();
            var viewResolution_1 = map.getView().getResolution();
            temperatureBaseLayers.forEach(function (layer) {
                if (layer.olLayer.getVisible() == true) {
                    var url = layer.olLayer
                        .getSource()
                        .getFeatureInfoUrl(e.coordinate, viewResolution_1, "EPSG:3857", {
                        INFO_FORMAT: "application/json",
                    });
                    if (url) {
                        try {
                            fetch(url)
                                .then(function (response) {
                                return response.json();
                            })
                                .then(function (json) {
                                if (json.features[0] != null) {
                                    popupContentHover.innerHTML = "".concat(json.features[0].properties[currentSpatialisedDataMeasure], " ").concat(currentSpatialisedDataMeasure == "tsa" ? "°C" : "%");
                                    spatialFeatureInfoJSON = json;
                                    popupOverlayHover.setPosition(e.coordinate);
                                }
                                else {
                                    spatialFeatureInfoJSON = null;
                                    popupOverlayHover.setPosition(undefined);
                                }
                            })
                                .catch(function (err) {
                                spatialFeatureInfoJSON = null;
                                popupOverlayHover.setPosition(undefined);
                                console.error(" Err: ".concat(err));
                            });
                        }
                        catch (error) {
                            spatialFeatureInfoJSON = null;
                            popupOverlayHover.setPosition(undefined);
                        }
                    }
                }
            });
        }
    });
    map.on("click", function (evt) {
        var feature = map.forEachFeatureAtPixel(evt.pixel, function (ft, layer) {
            return ft;
        });
        if (feature && feature.get("type") == "click") {
            if (userToken == "This user does not have any access to this page") {
                toast("Oups! Avez-vous oublié de vous connecter?", "info", "Si vous n'avez pas encore de compte, veuillez vous inscrire en <a href='".concat(window.location.protocol + "//" + window.location.hostname, "/fr/accounts/account_request/'>cliquant ici.</a>"));
                return;
            }
            var geometry = feature.getGeometry();
            var coord = geometry.getCoordinates();
            var iframeUrl = getIFrameUrl(feature.getProperties().properties.sid, currentMeasure, userToken);
            // let content = `
            //           <ul id="listPopupMeasureButton">
            //           <button id="popupens" class="popup-measure-button doubleicon" onclick="initStationChart('${
            //             feature.getProperties().properties.sid
            //           }','${userToken}','ens')" data-toggle="tooltip" data-placement="top" title="Ensoleillement"><i class="fas fa-sun"></i></button>
            //           <button id="popuptsa" class="popup-measure-button doubleicon selected" onclick="initStationChart('${
            //             feature.getProperties().properties.sid
            //           }','${userToken}','tsa')" data-toggle="tooltip" data-placement="top" title="Température"><i class="fa fa-thermometer-half" aria-hidden="true"></i></button>
            //           <button id="popuphra" class="popup-measure-button doubleicon" onclick="initStationChart('${
            //             feature.getProperties().properties.sid
            //           }','${userToken}','hra')" data-toggle="tooltip" data-placement="top" title="Humidité relative"><i class="fas fa-tint"></i></button>
            //           <button id="popuptsf" class="popup-measure-button doubleicon" onclick="initStationChart('${
            //             feature.getProperties().properties.sid
            //           }','${userToken}','tsf')" data-toggle="tooltip" data-placement="top" title="Température sous feuillage"><i class="fas fa-seedling"></i><i class="fa fa-thermometer-half" aria-hidden="true"></i></button>
            //           <button id="popuptss" class="popup-measure-button doubleicon" onclick="initStationChart('${
            //             feature.getProperties().properties.sid
            //           }','${userToken}','tss')" data-toggle="tooltip" data-placement="top" title="Température sous sol"><i class="fas fa-minus"></i><i class="fa fa-thermometer-half" aria-hidden="true"></i></button>
            //           <button id="popupdvt" class="popup-measure-button doubleicon" onclick="initStationChart('${
            //             feature.getProperties().properties.sid
            //           }','${userToken}','dvt')" data-toggle="tooltip" data-placement="top" title="Direction du vent à 2 mètres"><i class="fas fa-location-arrow"></i></button>
            //           <button id="popupvvt" class="popup-measure-button doubleicon" onclick="initStationChart('${
            //             feature.getProperties().properties.sid
            //           }','${userToken}','vvt')" data-toggle="tooltip" data-placement="top" title="Vitesse du vent à 2 mètres"><i class="fas fa-wind"></i></button>
            //           <button id="popupplu" class="popup-measure-button doubleicon" onclick="initStationChart('${
            //             feature.getProperties().properties.sid
            //           }','${userToken}','plu')" data-toggle="tooltip" data-placement="top" title="Précipitations"><i class="fas fa-cloud-rain"></i></button>
            //           <button id="popuphct" class="popup-measure-button doubleicon" onclick="initStationChart('${
            //             feature.getProperties().properties.sid
            //           }','${userToken}','hct')" data-toggle="tooltip" data-placement="top" title="Humectation du feuillage"><i class="fas fa-tint"></i><i class="fas fa-leaf"></i></button>
            //           </ul>
            //           <div id="station-graph" class="ol-popup-graph">
            //               <iframe class="graph-iframe" onload="onIFrameLoad(this)" src="${iframeUrl}"></iframe>
            //           </div>
            //           <button class="accessgraph"><i class="fas fa-long-arrow-alt-right"></i></button>
            //           `;
            // popupContent.innerHTML = content;
            /**
             * JPH 2022-02-11
             * construire le popup via des instructions JS pour obtenir le nom dynamique
             * des fonctions à appeler dans les events
             */
            /* Empty popupContent */
            if (popupContent.childElementCount !== 0) {
                popupContent.replaceChildren();
            }
            /* add the iframe and tools */
            var listbtn_1 = document.createElement("ul");
            listbtn_1.id = "listPopupMeasureButton";
            /* add a button for each sensor */
            var arrSensors = [
                { name: "ens", desc: "Ensoleillement", icon: ["fa-sun"] },
                { name: "tsa", desc: "Température", icon: ["fa-thermometer-half"] },
                { name: "hra", desc: "Humidité relative", icon: ["fa-tint"] },
                {
                    name: "tsf",
                    desc: "Température sous feuillage",
                    icon: ["fa-seedling", "fa-thermometer-half"],
                },
                {
                    name: "tss",
                    desc: "Température sous sol",
                    icon: ["fa-minus", "fa-thermometer-half"],
                },
                {
                    name: "dvt",
                    desc: "Direction du vent à 2 mètres",
                    icon: ["fa-location-arrow"],
                },
                { name: "vvt", desc: "Vitesse du vent à 2 mètres", icon: ["fa-wind"] },
                { name: "plu", desc: "Précipitations", icon: ["fa-cloud-rain"] },
                {
                    name: "hct",
                    desc: "Humectation du feuillage",
                    icon: ["fa-seedling"],
                },
            ];
            arrSensors.forEach(function (item) {
                var popitem = document.createElement("button");
                popitem.id = "popup".concat(item.name);
                popitem.classList.add("popup-measure-button", "doubleicon");
                popitem.setAttribute("data-toggle", "tooltip");
                popitem.setAttribute("data-placement", "top");
                popitem.title = item.desc;
                popitem.addEventListener("click", function () {
                    initStationChart(feature.getProperties().properties.sid, userToken, item.name);
                });
                /* add the icons */
                var idx = 0;
                item.icon.forEach(function (icon) {
                    var iconbtn = document.createElement("i");
                    iconbtn.classList.add("fas", icon);
                    if (idx > 0) {
                        iconbtn.setAttribute("aria-hidden", "true");
                    }
                    popitem.appendChild(iconbtn);
                    idx = idx + 1;
                });
                listbtn_1.appendChild(popitem);
            });
            popupContent.appendChild(listbtn_1);
            /* add the iframe to display grafana graph */
            var divgraph = document.createElement("div");
            divgraph.id = "station-graph";
            divgraph.classList.add("ol-popup-graph");
            var gphframe = document.createElement("iframe");
            gphframe.src = iframeUrl;
            gphframe.classList.add("graph-iframe");
            // gphframe.addEventListener("load", () => {
            //   onIFrameLoad(this);
            // });
            gphframe.addEventListener("load", function () {
                onIFrameLoad(this);
            });
            divgraph.appendChild(gphframe);
            popupContent.appendChild(divgraph);
            /* add a button for the chart */
            var accgraph = document.createElement("button");
            accgraph.classList.add("accessgraph");
            var iconbtn = document.createElement("i");
            iconbtn.classList.add("fas", "fa-long-arrow-alt-right");
            accgraph.appendChild(iconbtn);
            popupContent.appendChild(accgraph);
            popupOverlay.setPosition(coord);
            updatePrevisionIndicatorVisibility();
            highlighCurrentCHartMeasure(currentMeasure);
        }
        else {
            hideStationCharts();
            if (spatialFeatureInfoJSON != null) {
                spatialPixelClicked = true;
                // popupContentHover.innerHTML = `<iframe class="graph-iframe-spatial" onload="onIFrameLoad(this)" src="https://agromet.be/grafana/d-solo/spatiallinedata00/spatial-linedata?orgId=2&var-sensor=${currentMeasure}&var-px_id=${spatialFeatureInfoJSON.features[0].properties.px_id}&var-token=${userToken}&kiosk&autofitpanels&panelId=2"></iframe>`;
                /* Empty popupContentHover */
                if (popupContentHover.childElementCount !== 0) {
                    popupContentHover.replaceChildren();
                }
                /* add the iframe and tools */
                var gphframe = document.createElement("iframe");
                var charType = "";
                if (hourly == true) {
                    charType = "spatiallinedata00/spatial-linedata";
                }
                else {
                    charType = "spatiallinedatadaily00/spatial-linedata-daily";
                }
                gphframe.src = "".concat(geo_base_url, "/grafana/d-solo/").concat(charType, "?orgId=2&var-sensor=").concat(currentMeasure, "&var-px_id=").concat(spatialFeatureInfoJSON.features[0].properties.px_id, "&var-token=").concat(userToken, "&kiosk&autofitpanels&panelId=2");
                gphframe.classList.add("graph-iframe-spatial");
                // gphframe.addEventListener("load", () => {
                //   onIFrameLoad(this);
                // });
                gphframe.addEventListener("load", function () {
                    onIFrameLoad(this);
                });
                popupContentHover.appendChild(gphframe);
                spatialFeatureInfoJSON = null;
            }
            else {
                hideStationCharts();
                spatialPixelClicked = false;
            }
        }
    });
}
/**
 * Hide the popup containing the Graphana charts
 */
function hideStationCharts() {
    popupOverlay.setPosition(undefined);
}
/**
 * Hide side menu and nav bar in Graphana IFrame
 */
var onIFrameLoad = function (param) {
    param.contentWindow.addEventListener("keydown", function (e) {
        if (e.key === "Escape" || e.key == "Esc") {
            // escape key maps to keycode `27`
            var isbmenu = param.contentWindow.document.getElementsByTagName("sidemenu")[0];
            isbmenu.style.display = "none";
            var inavbar = param.contentWindow.document.getElementsByClassName("navbar")[0];
            inavbar.style.display = "none";
            return false;
        }
    }, true);
};
/**
 *
 * Generate the right IFrame URL according the @param {*} sid, the @param {*} measure  and the mode (hourly/daily)
 *
 */
function getIFrameUrl(sid, measure, usertoken) {
    var charType = "";
    /**
     * add panelId variable in case it will be different for different dashboards
     * 2021-09-21 all dashboards require value 2
     */
    var statistical_descriptor = currentDailyDataUnit;
    if (["plu", "ens"].includes(measure))
        statistical_descriptor = "sum";
    var panelId = "2";
    if (hourly == true) {
        if (previsional && previsionEnabled) {
            return "pasencoredispo"; // ne rien afficher pour le moment en prévision
            ["tsa"].includes(measure)
                ? (charType = "prevision01/previsions-tsa-tmy")
                : (charType = "prevision00/previsions");
        }
        else if (["plu", "ens"].includes(measure))
            charType = "stationbardata00/station-bardata";
        else if (["tsa"].includes(measure))
            charType = "stationlinedatatmy00/station-linedata-tmy";
        else
            charType = "stationlinedata00/station-linedata";
    }
    else {
        if (["plu", "ens"].includes(measure))
            charType = "stationbardatadaily00/station-bardata-daily";
        else if (["tsa"].includes(measure))
            charType = "stationlinedatatmydaily00/station-linedata-tmy-daily";
        else
            charType = "stationlinedatadaily00/station-linedata-daily";
    }
    var tempCurrentDate = new Date(currentDate);
    var from = tempCurrentDate.setDate(currentDate.getDate() - 14);
    currentDate.setHours(currentHour);
    var to = currentDate.getTime();
    var iframeUrl = "".concat(geo_base_url, "/grafana/d-solo/").concat(charType, "?orgId=2&var-sid=").concat(sid, "&var-sensor=").concat(measure, "&var-token=").concat(usertoken, "&kiosk&autofitpanels&from=").concat(from, "&to=").concat(to, "&panelId=").concat(panelId, "&statistical_descriptor=").concat(statistical_descriptor);
    return iframeUrl;
}
/**
 * Reset the station line chart
 */
var initStationChart = function (sid, usertoken, currentChartMeasure) {
    if (currentChartMeasure === void 0) { currentChartMeasure = ""; }
    var iframeUrl = getIFrameUrl(sid, currentChartMeasure, usertoken);
    var iframeDiv = document.getElementById("station-graph");
    // iframeDiv.innerHTML = `<iframe class="graph-iframe" src="${iframeUrl}"></iframe>`;
    if (iframeDiv.childElementCount !== 0) {
        iframeDiv.replaceChildren();
    }
    var gphframe = document.createElement("iframe");
    gphframe.src = iframeUrl;
    gphframe.classList.add("graph-iframe");
    iframeDiv.appendChild(gphframe);
    highlighCurrentCHartMeasure(currentChartMeasure);
};
/**
 *
 * Colorize the button corresponding to @param {*} currentChartMeasure
 */
function highlighCurrentCHartMeasure(currentChartMeasure) {
    if (currentChartMeasure === void 0) { currentChartMeasure = ""; }
    var measureToApplyChart = currentChartMeasure == "" ? currentMeasure : currentChartMeasure;
    var popupMeasureSelectors = document.querySelectorAll("#listPopupMeasureButton > button");
    var indexpopup = 0;
    for (indexpopup = 0; indexpopup < popupMeasureSelectors.length; ++indexpopup) {
        if (popupMeasureSelectors[indexpopup].id == "popup" + measureToApplyChart) {
            break;
        }
    }
    /* pour éviter une valeur aberrante sur un bug */
    if (indexpopup > popupMeasureSelectors.length - 1) {
        indexpopup = 0;
    }
    classSelectedToButton(popupMeasureSelectors, indexpopup);
}
/**
 * Hide slider interface according current data acquisition mode
 */
function initInterfaceSliders() {
    document.getElementById("daysRange").hidden = !daily;
    document.getElementById("labelDay").hidden = !daily;
    document.getElementById("hoursRange").hidden = !hourly;
    document.getElementById("labelHour").hidden = !hourly;
}
/**
 * WMS Layer printing reset
 */
function resetMapsZIndex() {
    parcelsTileLayer.setZIndex(0);
    baseSatTileLayer.setZIndex(0);
    parcelsTileLayer.setVisible(false);
    baseSatTileLayer.setVisible(false);
    map.removeLayer(parcelsTileLayer);
    map.removeLayer(baseSatTileLayer);
    resetTemperatureMap();
    baseTileLayer.setZIndex(10);
    popupOverlayHover.setPosition(undefined);
    classSelectedToBaseLayerButton(1);
}
/**
 * Hide Spatialised temperature
 */
function resetTemperatureMap() {
    temperatureBaseLayersActivated = false;
    if (temperatureBaseLayers != null) {
        temperatureBaseLayers.forEach(function (tempartureLayer) {
            tempartureLayer.olLayer.setZIndex(0);
            tempartureLayer.olLayer.setVisible(false);
            map.removeLayer(tempartureLayer.olLayer);
        });
        sensorLegendHide();
    }
    classSelectedToBaseLayerButton(1);
}
/**
 * Add base Open Street Map
 */
function addOSMToMap() {
    resetMapsZIndex();
    classSelectedToBaseLayerButton(1);
}
/**
 * Toggle OpenStreet Map Satellite raster
 */
function toggleSatOSMToMap() {
    if (baseSatTileLayer.getVisible()) {
        resetMapsZIndex();
    }
    else {
        resetMapsZIndex();
        map.addLayer(baseSatTileLayer);
        baseSatTileLayer.setVisible(true);
        baseSatTileLayer.setZIndex(15);
        classSelectedToBaseLayerButton(2);
    }
}
/**
 * Add Authorization Header to the API request
 * TODO : what are we gonna do for unauthenticated user?
 * */
function setupAuth() {
    $.ajaxSetup({
        headers: {
            Authorization: "Token " + $("#user_token").val(),
        },
    });
}
/**
 * Remove the printed layers on the map and reinitialize them with the selected date
 * */
function dateSelected() {
    removeVectorLayers();
    initializePameSebStations();
    if (temperatureBaseLayersActivated) {
        resetMapsZIndex();
        addTemperatureToMap();
    }
    updatePrevisionIndicatorVisibility();
    updateStationsStyle();
}
/**
 * Remove all the markers on the map
 * */
function removeVectorLayers() {
    map.getLayers().forEach(function (layer) {
        if (layer instanceof Vector)
            layer.getSource().clear();
    });
}
/**
 * Hide stations and update select button
 */
function hideStations() {
    map.getLayers().forEach(function (layer) {
        if (layer instanceof Vector)
            layer.setVisible(false);
    });
    var button = document.getElementById("toggleStationsButton");
    button.classList.remove("selected");
}
/**
 * Show stations and update select button
 */
function showStations() {
    map.getLayers().forEach(function (layer) {
        if (layer instanceof Vector)
            layer.setVisible(true);
    });
    var button = document.getElementById("toggleStationsButton");
    button.classList.add("selected");
}
/**
 * Initialize map data according the current mode (hourly/daily)
 **/
function initializePameSebStations() {
    if (hourly) {
        initializePameSebStationsHourly();
    }
    else {
        initializePameSebStationsDaily();
    }
    initInterfaceSliders();
}
/**
 * Generic way to call a toast
 * @param {*} message
 * @param {*} type
 * @param {*} description
 */
function toast(message, type, description) {
    if (description === void 0) { description = ""; }
    Swal.fire({
        title: message,
        html: description,
        icon: type,
    });
}
/**
 * Begin the tutorial
 */
function startIntro() {
    introJs().start();
    document.querySelector(".introjs-nextbutton").innerHTML = "Suivant";
    document.querySelector(".introjs-prevbutton").innerHTML = "Précédent";
    document.querySelector(".introjs-skipbutton").innerHTML = "Passer";
}
function beginLoading() {
    document.querySelector(".daterange").classList.add("hide");
    document.querySelector(".spinner").classList.remove("hide");
}
function endLoading() {
    document.querySelector(".daterange").classList.remove("hide");
    document.querySelector(".spinner").classList.add("hide");
}
/**
 * Setup and store previsional data
 */
function initializePrevisionalPameSedStations() {
    if (previsionEnabled == false)
        return;
    var apiBetaAgrometURL = "".concat(getBaseURL(), "/agromet/api/v3/get_pameseb_hourly_prev/all/all/5");
    var apiProdURL = geo_base_url + "/fr/agromet/api/v3/get_pameseb_hourly_prev/all/all/1/";
    beginLoading();
    $.getJSON(apiProdURL, function (data) {
        addPrevisionalPameSebStationsData(data);
        updateStationsStyle();
    });
    endLoading();
}
function addPrevisionalPameSebStationsData(data) {
    hourlyData.push.apply(hourlyData, data.results);
}
function isSidAuthorized(sid) {
    if (userStationsRestriction == null)
        return true;
    else if ((userStationsRestriction.length == 1 &&
        userStationsRestriction[0] == "anonymous") ||
        userStationsRestriction[0] == "")
        return true;
    else if (userStationsRestriction.includes(sid.toString()))
        return true;
    else
        return false;
}
function getAuthorizedParameters(userRestriction) {
    if (userRestriction == null)
        return "all";
    else if ((userRestriction.length == 1 && userRestriction[0] == "anonymous") ||
        userRestriction[0] == "")
        return "all";
    else
        return userRestriction.toString();
}
/**
 * Setup all hourly data and print them on the map
 * */
function initializePameSebStationsHourly() {
    //Compute range date to request
    currentDate = new Date(document.getElementById("dateSelect").value);
    var dateMinus24h = new Date(currentDate);
    dateMinus24h.setDate(dateMinus24h.getDate() - 1);
    // let datePlus24h = new Date(currentDate);
    // datePlus24h.setDate(datePlus24h.getDate() + 1);
    var beginRequestDate = dateMinus24h.toISOString().substring(0, 10);
    var endRequestDate = currentDate.toISOString().substring(0, 10);
    //Request to the API to get hourly data beween range date
    //setupAuth();
    var authorizedSations = getAuthorizedParameters(userStationsRestriction);
    var authorizedSensors = getAuthorizedParameters(userSensorsRestriction);
    //MH : Uncomment to disable sensors and stations filter
    // let authorizedSations = "all";
    // let authorizedSensors = "all";
    var apiAgrometURL = "".concat(getBaseURL(), "/agromet/api/v3/get_pameseb_hourly/").concat(authorizedSensors, "/").concat(authorizedSations, "/").concat(beginRequestDate, "/").concat(endRequestDate);
    beginLoading();
    $.getJSON(apiAgrometURL, function (data) {
        stationsData = data.references.stations;
        hourlyData = data.results;
        //Create points and stylize them on the map
        stationsData.forEach(function (element) {
            var layer = new Vector({
                source: new VectorSource({
                    features: [
                        new Feature({
                            type: "click",
                            geometry: new Point(fromLonLat([
                                parseFloat(element.longitude),
                                parseFloat(element.latitude),
                            ])),
                            properties: getStationHourlyMeasures(element.sid, hourlyData, currentHour),
                        }),
                    ],
                }),
                zIndex: 20,
            });
            map.addLayer(layer);
            stationLayers.push(layer);
        });
        updateStationsStyle();
        initializePrevisionalPameSedStations();
        endLoading();
    });
}
/**
 * Setup all daily data and print them on the map
 * */
function initializePameSebStationsDaily() {
    //Compute range date to request
    currentDate = new Date(document.getElementById("dateSelect").value);
    var fromDate = new Date(currentDate);
    var toDate = new Date(currentDate);
    /*
    JPH 2023-08-08 disable daySliderCentered to avoid no layers after selected date
    FIXME if this change remains, consider to remove all occurrences of daySliderCentered
    */
    // let differenceWithLastAvailableDate =
    //   getLastAvailableDatetime().getTime() - currentDate.getTime();
    // //If selected date is 7 days before last available date, set the date on slider in the middle
    // if (differenceWithLastAvailableDate > 1000 * 60 * 60 * 24 * 7) {
    //   daySliderCentered = true;
    //   fromDate.setDate(currentDate.getDate() - 7);
    //   toDate.setDate(currentDate.getDate() + 7);
    // } else {
    //   daySliderCentered = false;
    //   fromDate.setDate(currentDate.getDate() - 14);
    // }
    daySliderCentered = false;
    fromDate.setDate(currentDate.getDate() - 14);
    /* end JPH modification */
    initDaysSlider();
    //API request to get daily data between range date computed
    //setupAuth();
    var authorizedSations = getAuthorizedParameters(userStationsRestriction);
    var authorizedSensors = getAuthorizedParameters(userSensorsRestriction);
    //MH : Uncomment to disable sensors and stations filter
    // let authorizedSations = "all";
    // let authorizedSensors = "all";
    var apiAgrometURL = "".concat(getBaseURL(), "/agromet/api/v3/get_clean_daily/").concat(authorizedSensors, "/").concat(authorizedSations, "/").concat(fromDate
        .toISOString()
        .substring(0, 10), "/").concat(toDate.toISOString().substring(0, 10));
    beginLoading();
    $.getJSON(apiAgrometURL, function (data) {
        stationsData = data.references.stations;
        if (data.results == null || data.results.length == 0) {
            endLoading();
            toast("Pas de données disponnibles pour cette date", "error");
            return;
        }
        dailyData = data.results;
        //Create points and stylize them on the map
        stationsData.forEach(function (element) {
            var layer = new Vector({
                source: new VectorSource({
                    features: [
                        new Feature({
                            type: "click",
                            geometry: new Point(fromLonLat([
                                parseFloat(element.longitude),
                                parseFloat(element.latitude),
                            ])),
                            properties: getStationDailyMeasures(element.sid, dailyData, currentDateSlider),
                        }),
                    ],
                }),
                style: getPamesebStationStyle,
                zIndex: 20,
            });
            map.addLayer(layer);
            stationLayers.push(layer);
        });
        endLoading();
    });
}
/**
 * Update slider interface
 */
function initDaysSlider() {
    if (daySliderCentered) {
        document.getElementById("daysRange").value = "7";
    }
    else {
        document.getElementById("daysRange").value = "13";
    }
    currentDateSlider = new Date(currentDate);
    currentDateSlider.setDate(currentDateSlider.getDate());
    document.getElementById("labelDay").innerHTML =
        formatDate(currentDateSlider);
}
function formatDate(date) {
    var isoString = date.toISOString();
    var years = isoString.substring(0, 4);
    var month = isoString.substring(5, 7);
    var day = isoString.substring(8, 10);
    return "".concat(day, "-").concat(month, "-").concat(years);
}
function isSelectedTimePrevision() {
    var today = new Date();
    var dateOnScreen = new Date(document.getElementById("dateSelect").value);
    var hourOnScreen = currentHour;
    if (dateOnScreen > new Date())
        return true;
    if (dateOnScreen.getDate() >= today.getDate() &&
        dateOnScreen.getMonth() >= today.getMonth() &&
        dateOnScreen.getFullYear() >= today.getFullYear() &&
        hourOnScreen > today.getHours()) {
        return previsionEnabled ? true : false;
    }
    return false;
}
/**
 * Update de visibility of interface button according the sensors restrictions and the availibility of previsionnal data.
 */
function updatePrevisionIndicatorVisibility() {
    //MH : Uncomment to disable sensors and stations filter
    // return;
    var previsionIndicator = document.getElementById("previsionIndication");
    var popuptsa = document.getElementById("popuptsa");
    var popupens = document.getElementById("popupens");
    var popuphra = document.getElementById("popuphra");
    var popuptsf = document.getElementById("popuptsf");
    var popuptss = document.getElementById("popuptss");
    var popupdvt = document.getElementById("popupdvt");
    var popupvvt = document.getElementById("popupvvt");
    var popupplu = document.getElementById("popupplu");
    var popuphct = document.getElementById("popuphct");
    var tsa = document.getElementById("tsa");
    var ens = document.getElementById("ens");
    var hra = document.getElementById("hra");
    var tsf = document.getElementById("tsf");
    var tss = document.getElementById("tss");
    var dvt = document.getElementById("dvt");
    var vvt = document.getElementById("vvt");
    var plu = document.getElementById("plu");
    var hct = document.getElementById("hct");
    if (isSelectedTimePrevision()) {
        //Hide of sensors with no previsional data
        previsionIndicator.style.display = "block";
        popupens != null ? (popupens.style.display = "none") : null;
        popuptsf != null ? (popuptsf.style.display = "none") : null;
        popuptss != null ? (popuptss.style.display = "none") : null;
        popuphct != null ? (popuphct.style.display = "none") : null;
        previsional = true;
    }
    else {
        //Show sensors with no previsional data
        previsionIndicator.style.display = "none";
        popupens != null ? (popupens.style.display = "flex") : null;
        popuptsf != null ? (popuptsf.style.display = "flex") : null;
        popuptss != null ? (popuptss.style.display = "flex") : null;
        popuphct != null ? (popuphct.style.display = "flex") : null;
        previsional = false;
    }
    //Display logic of sensor selector buttons.
    if (userSensorsRestriction != null &&
        userSensorsRestriction.length > 0 &&
        userSensorsRestriction[0] != "" &&
        userSensorsRestriction[0] != "anonymous") {
        if (userSensorsRestriction.includes("tsa") == false) {
            popuptsa != null ? (popuptsa.style.display = "none") : null;
            tsa != null ? (tsa.style.display = "none") : null;
        }
        if (userSensorsRestriction.includes("ens") == false) {
            popupens != null ? (popupens.style.display = "none") : null;
            ens != null ? (ens.style.display = "none") : null;
        }
        if (userSensorsRestriction.includes("hra") == false) {
            popuphra != null ? (popuphra.style.display = "none") : null;
            hra != null ? (hra.style.display = "none") : null;
        }
        if (userSensorsRestriction.includes("tsf") == false) {
            popuptsf != null ? (popuptsf.style.display = "none") : null;
            tsf != null ? (tsf.style.display = "none") : null;
        }
        if (userSensorsRestriction.includes("tss") == false) {
            popuptss != null ? (popuptss.style.display = "none") : null;
            tss != null ? (tss.style.display = "none") : null;
        }
        if (userSensorsRestriction.includes("dvt") == false) {
            popupdvt != null ? (popupdvt.style.display = "none") : null;
            dvt != null ? (dvt.style.display = "none") : null;
        }
        if (userSensorsRestriction.includes("vvt") == false) {
            popupvvt != null ? (popupvvt.style.display = "none") : null;
            vvt != null ? (vvt.style.display = "none") : null;
        }
        if (userSensorsRestriction.includes("plu") == false) {
            popupplu != null ? (popupplu.style.display = "none") : null;
            plu != null ? (plu.style.display = "none") : null;
        }
        if (userSensorsRestriction.includes("hct") == false) {
            popuphct != null ? (popuphct.style.display = "none") : null;
            hct != null ? (hct.style.display = "none") : null;
        }
    }
}
/**
 * Update label and marker style according the new hour selected
 * */
function hourChanged(event) {
    currentHour = parseInt(event.target.value);
    document.getElementById("labelHour").innerHTML = "".concat(event.target.value, "H");
    updatePrevisionIndicatorVisibility();
    updateStationsStyle();
    if (temperatureBaseLayersActivated) {
        reorderSpatialTemperature();
    }
}
/**
 * Update label and marker style according the new day selected
 * */
function dayChanged(event) {
    var dateDelta = parseInt(event.target.value);
    currentDateSlider = new Date(currentDate);
    currentDateSlider.setDate(currentDateSlider.getDate() - ((daySliderCentered ? 7 : 13) - dateDelta));
    document.getElementById("labelDay").innerHTML =
        formatDate(currentDateSlider);
    document.getElementById("dateSelect").value =
        currentDateSlider.toISOString().substring(0, 10);
    updateStationsStyle();
    updatePrevisionIndicatorVisibility();
    if (temperatureBaseLayersActivated) {
        reorderSpatialTemperature();
    }
}
/**
 * Set a new style for each feature of the map according the mode (hourly/daily) and the value selected with the sliders
 * */
function updateStationsStyle() {
    stationLayers.forEach(function (station) {
        station.getSource().forEachFeature(function (feature) {
            if (feature.getProperties().properties != null) {
                if (hourly) {
                    feature.setProperties({
                        properties: getStationHourlyMeasures(feature.getProperties().properties.sid, hourlyData, currentHour),
                    });
                }
                else {
                    feature.setProperties({
                        properties: getStationDailyMeasures(feature.getProperties().properties.sid, dailyData, currentDateSlider),
                    });
                }
            }
        });
        station.setStyle(getPamesebStationStyle);
    });
}
/**
 * Parse API request's data in a common format for styling
 * */
function getStationDailyMeasures(sid, dailyData, day) {
    //Get data of the selected @day and the @sid
    var timedMeasures = dailyData.filter(function (element) {
        return element.sid == sid &&
            new Date(element.mdate).getUTCDate() === day.getUTCDate();
    });
    var timedMeasure;
    if (timedMeasures.length == 1) {
        timedMeasure = timedMeasures[0];
    }
    else {
        // let the station disappear if no more data
        return {
            sid: sid,
            mtime: day.getUTCDate(),
            tsa: null,
            tha: null,
            hra: null,
            tsf: null,
            tss: null,
            ens: null,
            dvt: null,
            vvt: null,
            plu: null,
            hct: null,
        };
    }
    var dvt = timedMeasure["dvt_".concat(currentDailyDataUnit)] == null
        ? null
        : Number(timedMeasure["dvt_".concat(currentDailyDataUnit)])
            .toFixed(0)
            .toString();
    return {
        sid: timedMeasure.sid,
        mtime: timedMeasure.mtime,
        tsa: timedMeasure["tsa_".concat(currentDailyDataUnit)],
        tha: timedMeasure["tha_".concat(currentDailyDataUnit)],
        hra: timedMeasure["hra_".concat(currentDailyDataUnit)],
        tsf: timedMeasure["tsf_".concat(currentDailyDataUnit)],
        tss: timedMeasure["tss_".concat(currentDailyDataUnit)],
        ens: timedMeasure["ens_sum"],
        dvt: dvt,
        vvt: timedMeasure["vvt_".concat(currentDailyDataUnit)],
        plu: Number(timedMeasure["plu_sum"]).toFixed(1).toString(),
        hct: timedMeasure["hct_".concat(currentDailyDataUnit)],
    };
}
/**
 * Parse API request's data in a common format for styling
 * */
function getStationHourlyMeasures(sid, hourlyData, hour) {
    //Get data of the selected @hour and the @sid
    // JPH 2021-03-02 added currentday to catch values at 0 hours.
    var currentDay = new Date(document.getElementById("dateSelect").value);
    var timedMeasures = hourlyData.filter(function (element) {
        return element.sid == sid &&
            new Date(element.mtime).getDate() === currentDay.getDate() &&
            new Date(element.mtime).getHours() === hour;
    });
    var timedMeasure;
    if (timedMeasures.length == 1) {
        timedMeasure = timedMeasures[0];
    }
    else {
        //timedMeasure = timedMeasures.filter((element) => (new Date(element.mtime)).toISOString().substring(0, 10) === currentDate.toISOString().substring(0, 10))[0];
        // JPH 2021-03-02 let the station disappear if no more data
        return {
            sid: sid,
            mtime: null,
            tsa: null,
            tha: null,
            hra: null,
            tsf: null,
            tss: null,
            ens: null,
            dvt: null,
            vvt: null,
            plu: null,
            hct: null,
        };
    }
    var dvt = timedMeasure.dvt == null
        ? null
        : Number(timedMeasure.dvt).toFixed(0).toString();
    return {
        sid: timedMeasure.sid,
        mtime: timedMeasure.mtime,
        tsa: timedMeasure.tsa,
        tha: timedMeasure.tha,
        hra: timedMeasure.hra,
        tsf: timedMeasure.tsf,
        tss: timedMeasure.tss,
        ens: timedMeasure.ens,
        dvt: dvt,
        vvt: timedMeasure.vvt,
        plu: Number(timedMeasure.plu).toFixed(1).toString(),
        hct: timedMeasure.hct,
    };
}
/**
 * Get color corresponding to the @param {*} temparture
 */
function getSquareColor(temparture) {
    var red, green, blue;
    //Compute the ratio between the @temparture and its place between the min and max value and set it on a 255 base.
    var ratio = 255 -
        Math.floor(((temparture - minSpatialTemperature) /
            (maxSpatialTemperature - minSpatialTemperature)) *
            255);
    //Set color according the color theme
    red = 255;
    green = ratio;
    blue = 0;
    return "".concat(red, ",").concat(green, ",").concat(blue);
}
/**
 * Compute the angle of the arrow correctiong to @param {*} value
 */
function getWindRotation(value) {
    return value - 180;
}
/**
 * Compute a color for the marker
 * @measureValue is the value of one measure for one station
 * Le color results in a hexadecimal color code
 * The goal is to have a color with more contrast when the @measureValue is high compared to the other measure of the same hour/day
 * */
function getMarkerColor(measureValue) {
    // use of fixed scales for TSA and HRA
    if (fixedStepColorsTemperature)
        return getFixedStepTSAColor(measureValue);
    if (fixedStepColorsHRA)
        return getFixedStepHRAColor(measureValue);
    //Get all value of the measure of the date range
    var allData;
    if (hourly) {
        allData = hourlyData.map(function (element) { return element[currentMeasure]; });
    }
    else {
        var dailyColorCataToCompute_1 = currentMeasure == "ens" || currentMeasure == "plu"
            ? "".concat(currentMeasure, "_sum")
            : "".concat(currentMeasure, "_").concat(currentDailyDataUnit);
        allData = dailyData.map(function (element) { return element[dailyColorCataToCompute_1]; });
    }
    //Compute minimum and maximum value
    var minValue = Math.min.apply(Math, allData);
    var maxValue = Math.max.apply(Math, allData);
    //If there is no variability in the values, set the color to grey
    if (minValue == maxValue)
        return "808080";
    var red, green, blue;
    //Compute the ratio between the @measureValue and its place between the min and max value and set it on a 255 base.
    var ratio = 255 - Math.floor(((measureValue - minValue) / (maxValue - minValue)) * 255);
    //Set color according the color theme
    if (getCurrentColorMap() == "warm") {
        red = 255;
        green = ratio;
        blue = 0;
    }
    else {
        red = 0;
        green = ratio;
        blue = 255;
    }
    return (intToHex(red) + intToHex(green) + intToHex(blue)).toUpperCase();
}
/**
 * Return the color corresponding to @param {*} value
 */
function getFixedStepHRAColor(value) {
    if (value > 10 && value <= 15) {
        return "e31a1c";
    }
    else if (value > 15 && value <= 20) {
        return "e4331c";
    }
    else if (value > 20 && value <= 25) {
        return "e54c1b";
    }
    else if (value > 25 && value <= 30) {
        return "e6651b";
    }
    else if (value > 30 && value <= 35) {
        return "e77f1b";
    }
    else if (value > 35 && value <= 40) {
        return "e8981b";
    }
    else if (value > 40 && value <= 45) {
        return "e9b11b";
    }
    else if (value > 45 && value <= 50) {
        return "eaca1b";
    }
    else if (value > 50 && value <= 55) {
        return "eae41b";
    }
    else if (value > 55 && value <= 60) {
        return "d3df1b";
    }
    else if (value > 60 && value <= 62) {
        return "bcdb1a";
    }
    else if (value > 62 && value <= 64) {
        return "a4d619";
    }
    else if (value > 64 && value <= 66) {
        return "8dd219";
    }
    else if (value > 66 && value <= 68) {
        return "5ec917";
    }
    else if (value > 68 && value <= 70) {
        return "47c517";
    }
    else if (value > 70 && value <= 72) {
        return "30c016";
    }
    else if (value > 72 && value <= 74) {
        return "30c016";
    }
    else if (value > 74 && value <= 76) {
        return "2dc330";
    }
    else if (value > 76 && value <= 78) {
        return "2ac749";
    }
    else if (value > 78 && value <= 80) {
        return "28ca63";
    }
    else if (value > 80 && value <= 82) {
        return "25cd7d";
    }
    else if (value > 82 && value <= 84) {
        return "22d096";
    }
    else if (value > 84 && value <= 86) {
        return "20d3b0";
    }
    else if (value > 86 && value <= 88) {
        return "1dd6ca";
    }
    else if (value > 88 && value <= 90) {
        return "1ad9e3";
    }
    else if (value > 90 && value <= 92) {
        return "19bfd8";
    }
    else if (value > 92 && value <= 94) {
        return "17a5cc";
    }
    else if (value > 94 && value <= 96) {
        return "158bc1";
    }
    else if (value > 96 && value <= 98) {
        return "1370b5";
    }
    else if (value > 98) {
        return "1256aa";
    }
    else {
        return "e31a1c";
    }
    /*
      if (value > 95) {
          return "4D629C";
      } else if (value > 90 && value <= 95) {
          return "4C68AD";
      } else if (value > 85 && value <= 90) {
          return "4868B7";
      } else if (value > 80 && value <= 85) {
          return "426EC6";
      } else if (value > 75 && value <= 80) {
          return "407DD4";
      } else if (value > 70 && value <= 75) {
          return "3E8ADC";
      } else if (value > 65 && value <= 70) {
          return "4AAAD5";
      } else if (value > 60 && value <= 65) {
          return "54C2D8";
      } else if (value > 55 && value <= 60) {
          return "59D2DB";
      } else if (value > 50 && value <= 55) {
          return "5FD3D4";
      } else if (value > 45 && value <= 50) {
          return "69D6C8";
      } else if (value > 40 && value <= 45) {
          return "72DFBC";
      } else if (value > 35 && value <= 40) {
          return "7BE2B0";
      } else if (value > 30 && value <= 35) {
          return "83DEA7";
      } else if (value > 25 && value <= 30) {
          return "9FE3A9";
      } else if (value > 20 && value <= 25) {
          return "B3E2B5";
      } else if (value <= 20) {
          return "DCEEEA";
      }*/
}
/**
 * Return the color corresponding to @param {*} value
 */
function getFixedStepTSAColor(value) {
    if (value <= -3) {
        return "0d0887";
    }
    else if (value > -3 && value <= -2) {
        return "0e2293";
    }
    else if (value > -2 && value <= -1) {
        return "103c9e";
    }
    else if (value > -1 && value <= 0) {
        return "1256aa";
    }
    else if (value > 0 && value <= 1) {
        return "1370b5";
    }
    else if (value > 1 && value <= 2) {
        return "158bc1";
    }
    else if (value > 2 && value <= 3) {
        return "17a5cc";
    }
    else if (value > 3 && value <= 4) {
        return "19bfd8";
    }
    else if (value > 4 && value <= 5) {
        return "1ad9e3";
    }
    else if (value > 5 && value <= 6) {
        return "1dd6ca";
    }
    else if (value > 6 && value <= 7) {
        return "20d3b0";
    }
    else if (value > 7 && value <= 8) {
        return "22d096";
    }
    else if (value > 8 && value <= 9) {
        return "25cd7d";
    }
    else if (value > 9 && value <= 10) {
        return "28ca63";
    }
    else if (value > 10 && value <= 11) {
        return "2ac749";
    }
    else if (value > 11 && value <= 12) {
        return "2dc330";
    }
    else if (value > 12 && value <= 13) {
        return "30c016";
    }
    else if (value > 13 && value <= 14) {
        return "47c517";
    }
    else if (value > 14 && value <= 15) {
        return "5ec917";
    }
    else if (value > 15 && value <= 16) {
        return "76cd18";
    }
    else if (value > 16 && value <= 17) {
        return "8dd219";
    }
    else if (value > 17 && value <= 18) {
        return "a4d619";
    }
    else if (value > 18 && value <= 19) {
        return "bcdb1a";
    }
    else if (value > 19 && value <= 20) {
        return "d3df1b";
    }
    else if (value > 20 && value <= 21) {
        return "eae41b";
    }
    else if (value > 21 && value <= 22) {
        return "eaca1b";
    }
    else if (value > 22 && value <= 23) {
        return "e9b11b";
    }
    else if (value > 23 && value <= 24) {
        return "e8981b";
    }
    else if (value > 24 && value <= 25) {
        return "e77f1b";
    }
    else if (value > 25 && value <= 26) {
        return "e6651b";
    }
    else if (value > 26 && value <= 27) {
        return "e54c1b";
    }
    else if (value > 27 && value <= 28) {
        return "e4331c";
    }
    else if (value > 28) {
        return "e31a1c";
    }
    else {
        /* added to respect strict compilation */
        return "0d0887";
    }
}
/**
 * Utility function to convert a 0-255 integer to a hexadecimal string
 * */
function intToHex(value) {
    var hexa = value.toString(16);
    if (hexa.length == 1) {
        return "0" + hexa;
    }
    else {
        return hexa;
    }
}
/**
 * Return the color theme of the current selected measure
 * */
function getCurrentColorMap() {
    switch (currentMeasure) {
        case "tsa":
        case "tha":
        case "tsf":
        case "tss":
        case "ens":
        case "vvt":
            return "warm";
        case "plu":
        case "hra":
        case "hct":
        case "dvt":
            return "cold";
        default:
            return "";
    }
}
/**
 * Return the unit of the current selected measures
 * */
function getCurrentUnit() {
    switch (currentMeasure) {
        case "tsa":
            return "°C";
        case "tha":
            return "°C";
        case "plu":
            return "mm";
        case "hra":
            return "%";
        case "ens":
            if (hourly)
                return "W/m²";
            else
                return "J/cm²";
        case "hct":
            return "min";
        case "vvt":
            return "m/s";
        case "dvt":
            return "";
        case "tsf":
            return "°C";
        case "tss":
            return "°C";
        default:
            return "";
    }
}
/**
 * Generate the OpenLayer Style to apply on the station
 * @param {*} point
 */
// function getSpatialTemparatureStyle(point: any): Style[] {
//   return [
//     new Style({
//       fill: new Fill({
//         color: `rgba(${getSquareColor(
//           point.getProperties()[currentSpatialisedDataMeasure]
//         )}, 0.8)`,
//       }),
//     }),
//   ];
// }
/**
 * Create and style a point representing a station on the map
 * */
function getPamesebStationStyle(point) {
    var time = point.getProperties().properties["mtime"];
    var now = new Date(Date.now());
    var isPrevision = false;
    if (new Date(time) > now && previsionEnabled) {
        isPrevision = true;
    }
    //Get the correct color of the point and set the background svg colored
    var markerColor = getMarkerColor(point.getProperties().properties[currentMeasure]);
    var svg;
    if (isPrevision) {
        svg =
            "%3Csvg width='62px' height='80px' viewBox='0 0 62 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='white' stroke-width='3' filter='url(%23filter0_d)'%3E%3Cpath d='M62,29.9V4.4C62,2,60,0,57.4,0H4.6C2,0,0,2,0,4.4v26l0,0c0.1,11.8,4.6,15.4,27.8,48c1.5,2.2,4.8,2.2,6.4,0C57.6,45.5,62,42.1,62,30C62,30,62,29.9,62,29.9z' fill='%23" +
                markerColor +
                "'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d' x='0' y='0' width='62' height='80' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dy='4'/%3E%3CfeGaussianBlur stdDeviation='2'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E";
    }
    else {
        svg =
            "%3Csvg width='62px' height='80px' viewBox='0 0 62 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_d)'%3E%3Cpath d='M28.2252 70.5473C7.79266 40.9262 4 37.8862 4 27C4 12.0883 16.0883 0 31 0C45.9117 0 58 12.0883 58 27C58 37.8862 54.2073 40.9262 33.7748 70.5473C32.434 72.4843 29.5659 72.4842 28.2252 70.5473Z' fill='%23" +
                markerColor +
                "'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d' x='0' y='0' width='62' height='80' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dy='4'/%3E%3CfeGaussianBlur stdDeviation='2'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E";
    }
    var text = point.getProperties().properties[currentMeasure];
    text = formatStationText(text);
    //Init the text (measure value) and the unit to print on the background image
    var unit = getCurrentUnit();
    if (point.getProperties().properties[currentMeasure] == null ||
        point.getProperties().properties[currentMeasure] < -1000)
        return [];
    var textOffset = -40;
    var unitOffset = -27;
    var scale = 0.7;
    //Set specific style for wind direction
    if (currentMeasure == "dvt") {
        var windAngleRotatation = getWindRotation(point.getProperties().properties[currentMeasure]);
        svg = "%3Csvg width='70' height='70' viewBox='0 0 70 70' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M26.9811 1.70198L0.133815 57.9999C-0.51099 59.3036 1.30619 60.5589 2.77165 59.7381L23.6399 48.3916C27.5087 46.2672 32.4913 46.2672 36.3601 48.3916L57.2283 59.7381C58.6938 60.5106 60.511 59.3036 59.8662 57.9999L32.9602 1.70198C31.9051 -0.567325 28.0949 -0.567325 26.9811 1.70198Z' transform=\"rotate(".concat(windAngleRotatation, ",30,30)\" fill='%2300A651'/%3E%3C/svg%3E%0A");
        textOffset = -26;
        unitOffset = 10;
        scale = 0.7;
    }
    //Return 3 styles (SVG,value,unit) to render the station
    return [
        new Style({
            text: new Text({
                text: text,
                placement: "point",
                offsetY: textOffset,
                font: "bold 12px Montserrat",
                fill: new Fill({ color: "rgba(255, 255, 255, 1)" }),
                stroke: new Stroke({
                    width: 1,
                    color: "rgba(0, 0, 0, 0.2)",
                }),
            }),
        }),
        new Style({
            text: new Text({
                text: unit,
                placement: "point",
                offsetY: unitOffset,
                font: "bold 9px Montserrat",
                fill: new Fill({ color: "rgba(255, 255, 255, 1)" }),
                stroke: new Stroke({
                    width: 1,
                    color: "rgba(0, 0, 0, 0.2)",
                }),
            }),
        }),
        new Style({
            image: new Icon({
                opacity: 1,
                src: "data:image/svg+xml;utf8," + svg,
                scale: scale,
                anchor: [0.5, 1],
            }),
        }),
    ];
}
/**
 * Formating output text on ens and hct sensors
 * @param {*} text
 */
function formatStationText(text) {
    switch (currentMeasure) {
        case "ens":
            if (hourly)
                return Math.round(text).toString();
            else
                return Math.round(text).toString();
        case "hct":
            return Math.round(text).toString();
        default:
            return text;
    }
}
/**
 * Set the @measure as the current measure and update the styles of the stations on the map
 * */
function setMeasure(measure) {
    currentMeasure = measure;
    // if (measure == "hra" || measure == "tsa") {
    if (availableSpatializedMeasures.includes(measure)) {
        currentSpatialisedDataMeasure = measure;
        switchSpatialMap();
    }
    else {
        currentSpatialisedDataMeasure = "";
        resetTemperatureMap();
    }
    updateFixedColorisation();
    updateStationsStyle();
    var measureBoutton = (document.getElementById(measure));
    setMeasureListOrder(measureBoutton);
    //openMeasureList();
    closeOutMeasureList();
    setDailyDataUnitVisibility();
}
function updateFixedColorisation() {
    fixedStepColorsTemperature = false;
    fixedStepColorsHRA = false;
    switch (currentMeasure) {
        case "hct":
        case "ens":
            break;
        case "hra":
            fixedStepColorsHRA = true;
            break;
        default:
            fixedStepColorsTemperature = true;
            break;
    }
}
/**
 * Set the @measure as the selected item in the list
 * */
function setMeasureListOrder(measureBoutton) {
    var infoSelectors = document.querySelectorAll("#info_selectors > li");
    infoSelectors.forEach(function (selector) {
        selector.classList.remove("selected");
        selector.children[0].classList.remove("selected");
        if (selector.id == measureBoutton.id) {
            selector.classList.add("selected");
            selector.children[0].classList.add("selected");
        }
    });
}
/**
 * Open the expandable list
 * */
function openMeasureList() {
    var infoSelectors = document.querySelectorAll("#info_selectors > li");
    infoSelectors.forEach(function (selector) {
        if (!selector.classList.contains("expandable")) {
            selector.classList.add("expandable");
        }
    });
}
/**
 * Apply right css classes to the sensors selctor on the open
 */
function openHoverMeasureList() {
    var infoSelectors = document.querySelectorAll("#info_selectors > li");
    infoSelectors.forEach(function (selector) {
        if (!selector.classList.contains("expandable")) {
            selector.classList.add("expandable");
        }
    });
}
/**
 * Apply right css classes to the sensors selctor on the close
 */
function closeOutMeasureList() {
    var infoSelectors = document.querySelectorAll("#info_selectors > li");
    infoSelectors.forEach(function (selector) {
        if (selector.classList.contains("expandable")) {
            selector.classList.remove("expandable");
        }
    });
}
/**
 * Initialization of help user popup based on hidden input "msg_to_user"
 * The popup is shown if the user is not connected and not on a mobile phone
 */
function initializeMsgToUserPopup() {
    document.getElementById("popup-msg-to-user-text").innerHTML = msgToUser;
    if (!isMobile()) {
        if (Date.now() <= msgToUserEnd.getTime() &&
            Date.now() >= msgToUserStart.getTime()) {
            document.getElementById("popup-msg-to-user").removeAttribute("hidden");
        }
    }
}
/**
 * Hide the user help popup
 */
function closeMsgToUserPopup() {
    document.getElementById("popup-msg-to-user").setAttribute("hidden", "true");
    setCookie("showMsgToUser", "false", 1);
}
function setCookie(cname, cvalue, exdays) {
    if (exdays === void 0) { exdays = 1; }
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie =
        cname + "=" + cvalue + ";" + expires + ";path=/;SameSite=Strict;";
}
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
/**
 * Set the visibility of Daily Data Unit Boutons
 * */
function setDailyDataUnitVisibility() {
    var min = document.getElementById("min");
    var max = document.getElementById("max");
    var avg = document.getElementById("avg");
    if (hourly) {
        min.classList.add("hide");
        max.classList.add("hide");
        avg.classList.add("hide");
    }
    else {
        if (currentMeasure == "ens" || currentMeasure == "plu") {
            min.classList.add("hide");
            max.classList.add("hide");
            avg.classList.add("hide");
        }
        else if (currentMeasure == "dvt") {
            min.classList.add("hide");
            max.classList.add("hide");
            avg.classList.remove("hide");
        }
        else {
            min.classList.remove("hide");
            max.classList.remove("hide");
            avg.classList.remove("hide");
        }
    }
}
/**
 * Set the @unit as the current daily unit and update the styles of the stations on the map (min,avg,max)
 * */
function setDailyDailyDataUnit(unit) {
    currentDailyDataUnit = unit;
    var min = document.getElementById("min");
    var max = document.getElementById("max");
    var avg = document.getElementById("avg");
    var index = 0;
    switch (unit) {
        case "min":
            index = 0;
            break;
        case "max":
            index = 1;
            break;
        case "avg":
            index = 2;
            break;
    }
    classSelectedToButton([min, max, avg], index);
    updateStationsStyle();
    if (temperatureBaseLayersActivated)
        addTemperatureToMap();
}
/**
 * Mobile browser detection
 */
function isMobile() {
    var toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
    ];
    return toMatch.some(function (toMatchItem) {
        return navigator.userAgent.match(toMatchItem);
    });
}
/**
 * Initialiser la page une fois tout lu
 */
init();
